var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmaterialpersonoutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person-outline",
    "data-name": "Icon material-person-outline",
    d: "M18,8.85A3.15,3.15,0,1,1,14.85,12,3.15,3.15,0,0,1,18,8.85m0,13.5c4.455,0,9.15,2.19,9.15,3.15v1.65H8.85V25.5c0-.96,4.695-3.15,9.15-3.15M18,6a6,6,0,1,0,6,6A6,6,0,0,0,18,6Zm0,13.5c-4.005,0-12,2.01-12,6V30H30V25.5C30,21.51,22.005,19.5,18,19.5Z",
    transform: "translate(-6 -6)",
    fill: "#6993ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmaterialpersonoutline);
export default __webpack_public_path__ + "static/media/Icon materialpersonoutline.d3d969022c40175b87584f2174785744.svg";
export { ForwardRef as ReactComponent };